
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobEducationCourseSpecialty, deleteJobEducationCourseSpecialty, fetchEducationCourseSpecialty, fetchJobEducationCourseSpecialty, updateJobEducationCourseSpecialty } from "./JobEducationCourseSpecialtyAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobEducationCourseSpecialtyAsync = createAsyncThunk(
  "Specialty/fetch",
  async (selectedCourseUuid, { rejectWithValue }) => {
    try {
      const data = await fetchJobEducationCourseSpecialty(selectedCourseUuid);
      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchEducationCourseSpecialtyAsync = createAsyncThunk(
  "EducationSpecialty/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchEducationCourseSpecialty();
      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteJobEducationCourseSpecialtyAsync = createAsyncThunk(
  'Specialty/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobEducationCourseSpecialty(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const updateJobEducationCourseSpecialtyAsync = createAsyncThunk(
  'Specialty/update',
  async ({ uuid, jobEducationCourseSpecialtyData }, { rejectWithValue }) => {
    try {
      const response = await updateJobEducationCourseSpecialty(uuid, jobEducationCourseSpecialtyData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobEducationCourseSpecialtyAsync = createAsyncThunk(
  "Specialty/add",
  async (jobEducationCourseSpecialtyData) => {
    try {
      const data = await addJobEducationCourseSpecialty(jobEducationCourseSpecialtyData);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const jobEducationCourseSpecialtySlice = createSlice({
  name: "jobEducationCourseSpecialty",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobEducationCourseSpecialtyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobEducationCourseSpecialtyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobEducationCourseSpecialtyAsync.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || action.error.message;
        state.error = action.error.message || "An error occurred"; // Store only the message
      })
      .addCase(fetchEducationCourseSpecialtyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEducationCourseSpecialtyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchEducationCourseSpecialtyAsync.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || action.error.message;
        state.error = action.error.message || "An error occurred"; // Store only the message
      })

      
      .addCase(addJobEducationCourseSpecialtyAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobEducationCourseSpecialtyAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateJobEducationCourseSpecialtyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobEducationCourseSpecialtyAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.data) {
          state.data = [];
        }
        state.data = state.data.map((jobTitle) =>
          jobTitle.uuid === action.payload.uuid ? action.payload : jobTitle
        );
      })
      .addCase(updateJobEducationCourseSpecialtyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteJobEducationCourseSpecialtyAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobEducationCourseSpecialtyAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (jobEducationCourse) => jobEducationCourse.uuid !== action.payload
        );
      })
      .addCase(deleteJobEducationCourseSpecialtyAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectJobEducationCourseSpecialty = (state) => state.jobEducationCourseSpecialty.data;

export default jobEducationCourseSpecialtySlice.reducer;
